import React, {Fragment} from "react";
import { translate } from "react-i18next";
import { compose } from "redux";
import MappingSetTree from './mapping-set-tree';
import MappingSetWizard from "./mapping-set-wizard";

const MappingSet = () => (
    <Fragment>
        <MappingSetTree/>
        <MappingSetWizard/>
    </Fragment>
)


export default compose(
    translate()
)(MappingSet);